import { Avatar } from "@chakra-ui/react";
import { useUser } from "../hooks/user.hooks";
import { cn } from "../lib/utils";

function UserAvatar({ userId, logo }: { userId: number; logo?: boolean }) {
	const { data: user } = useUser(userId);

	if (!user) {
		return <>---</>;
	}
	return (
		<div className="hflex items-center">
			{(logo === undefined || logo === true) && (
				<Avatar
					name={`${user.firstName} ${user.lastName}`}
					src="https://bit.ly/cbouchard"
					h="40px"
					w="40px"
					mr="10px"
				/>
			)}
			<div className="vflex">
				<div
					className={cn(
						"text-xs font-medium text-gray-900 leading-4 capitalize",
					)}
				>
					{user.firstName} {user.lastName}
				</div>
				{user.isSuperAdmin && (
					<div className={cn("text-xs font-medium text-gray-500 leading-4")}>
						Supembouts
					</div>
				)}
				{!user.isSuperAdmin && (
					<div className={cn("text-xs font-medium text-gray-500 leading-4")}>
						Utilisateur
					</div>
				)}
			</div>
		</div>
	);
}

export default UserAvatar;
